<template>
  <v-skeleton-loader
    type="list-item-avatar,list-item-two-line,list-item-two-line,list-item-two-line,list-item-two-line"
    height="auto"
    :loading="false"
    boilerplate
  >
    <div class="mt-4 legal-entity">
      <v-card
        :max-height="$vuetify.breakpoint.mdAndDown ? '' : '400'"
        class="dashboard-withdraw-card pa-4 "
        color="gray10"
        flat
      >
        <v-row justify="space-between " align="center" class="title">
          <v-col class="px-4 py-0">
            <v-icon>$editList</v-icon>
            <span class="mb-0 font-Medium-14 gray1--text">
              {{ $t("corporateAccount.permissionsCartable.licensesCartable") }}
            </span>
          </v-col>
          <v-col cols="auto" class="py-0 px-4">
            <router-link
              class="primary--text"
              to="/legal-entity/permissions-cartable"
            >
              {{ $t("shared.seeMore") }}
              <!--              <v-icon-->
              <!--                size="20"-->
              <!--                class=""-->
              <!--                clr="var(&#45;&#45;v-gray1-base)"-->
              <!--                :class="{ 'transfor-x': !$vuetify.rtl }"-->
              <!--              >-->
              <!--                $vuetify.CustomIcons.arrow-->
              <!--              </v-icon>-->
            </router-link>
          </v-col>
        </v-row>

        <v-row
          justify="center"
          align="center"
          class="no-message"
          v-if="data.length <= 0"
        >
          <v-col class="py-0 px-4 text-center">
            <p class="font-Regular-12 no-message-text mb-0 mt-2">
              {{ $t("corporateAccount.permissionsCartable.noWithdrawalFound") }}
            </p>
          </v-col>
        </v-row>

        <div v-else>
          <v-card
            v-for="(item, index) in data"
            :key="index"
            :to="
              `/legal-entity/submit-order/${
                item.reference_number
              }/withdrawal/crypto?category=${
                item.currency_iso === 'IRR' ? 'IRR' : 'cryptoCurrency'
              }`
            "
            class="card pa-4 mt-3"
            color="gray8"
            flat
          >
            <div class="d-flex align-center justify-space-between">
              <span
                >{{ $t("corporateAccount.permissionsCartable.withdrawal") }}
                {{ item.currency_iso }}</span
              >
              <span>{{ $thousandMask(item.currency_amount) }}</span>
            </div>
            <div
              class="d-flex flex-column flex-md-row align-center justify-space-between mt-2"
            >
              <div
                class="d-flex align-md-center  flex-column flex-md-row  font-Regular-14 gray2--text w-100"
              >
                <span>{{ item.created_at | formatDate }}</span>
                <span class="ms-md-4"
                  >{{ $t("corporateAccount.permissionsCartable.requester") }} :
                  {{ item.creator_user }}</span
                >
              </div>
              <div class="d-flex align-center justify-end  mt-4 mt-md-0 w-100">
                <div class="status-in-table me-10" style="width: max-content">
                  <span
                    class="font-Regular-12"
                    :class="{
                      'info-status':
                        item.status.value === 'CREATED' ||
                        item.status.value === 'PRECESSING',
                      'error-status': item.status.value === 'CANCELED'
                    }"
                  >
                    {{ item.status.locale }}
                  </span>
                </div>
                <v-icon
                  :class="{ 'transfor-x': !$vuetify.rtl }"
                  clr="var(--v-gray1-base)"
                >
                  $arrowLeft
                </v-icon>
              </div>
            </div>
          </v-card>
        </div>
      </v-card>
    </div>
  </v-skeleton-loader>
</template>

<script>
import legalService from "@/services/modules/legalService";
import $thousandMask from "@/mixins/thousandMask";
export default {
  mixins: [$thousandMask],
  props: {
    perPage: {
      default: 2,
      type: Number
    }
  },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.fetchNeedAcceptance();
  },
  methods: {
    fetchNeedAcceptance() {
      legalService
        .needAcceptance({ per_page: this.perPage, currency_type: "rial" })
        .then(res => {
          this.data = res.data.data;
        });
    }
  }
};
</script>

<style scoped lang="scss">
.dashboard-withdraw-card {
  overflow-y: scroll;
  .no-message {
    height: 275px;
    &-text {
      color: #bbb;
    }
  }
  .withdraw-row {
    background-color: var(--v-lightest-base);
    border-radius: 12px;
  }
}
</style>
